import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth.js';
import { AppShell } from './components/AppShell.js';
import { Login } from './pages/Login.js';
import { Dashboard } from './pages/Dashboard.js';
import { Customers } from './pages/Customers.js';
import { CustomerDetail } from './pages/CustomerDetail.js';
import { Leads } from './pages/Leads.js';
import { JobsList } from './pages/JobsList.js';
import { InvoicesList } from './pages/InvoicesList.js';
import { Schedule } from './pages/Schedule.js';
import { Dispatch } from './pages/Dispatch.js';
import { Inbox } from './pages/Inbox.js';
import { Settings } from './pages/Settings.js';
import { TaxCenter } from './pages/TaxCenter.js';
import { MyDay } from './pages/MyDay.js';
import { MobileJob } from './pages/MobileJob.js';
import { Automations } from './pages/Automations.js';
import { Website } from './pages/Website.js';

export function App() {
  const { session } = useAuth();
  if (!session) return <Login />;
  // Role-aware home: a technician lands on the mobile "Today" flow; office/owner on the dashboard.
  const techOnly = session.roles.length === 1 && session.roles[0] === 'technician';
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={techOnly ? <MyDay /> : <Dashboard />} />
        <Route path="my" element={<MyDay />} />
        <Route path="my/:cid/:jid" element={<MobileJob />} />
        <Route path="leads" element={<Leads />} />
        <Route path="customers" element={<Customers />} />
        <Route path="customers/:id" element={<CustomerDetail />} />
        <Route path="jobs" element={<JobsList />} />
        <Route path="schedule" element={<Schedule />} />
        <Route path="dispatch" element={<Dispatch />} />
        <Route path="inbox" element={<Inbox />} />
        <Route path="automations" element={<Automations />} />
        <Route path="website" element={<Website />} />
        <Route path="settings" element={<Settings />} />
        <Route path="invoices" element={<InvoicesList />} />
        <Route path="tax" element={<TaxCenter />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
